import { useTranslation } from 'react-i18next'
import { CONTRACT_TYPE_BADGE_CLASS } from '../../../utils/workforceUtils'

const Toggle = ({ value, onChange, ariaLabel }) => (
  <button
    type="button"
    onClick={() => onChange(!value)}
    onKeyDown={e => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault()
        onChange(!value)
      }
    }}
    className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors ${value ? 'bg-green-500' : 'bg-gray-300'}`}
    aria-pressed={value}
    aria-label={ariaLabel}
  >
    <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${value ? 'translate-x-6' : 'translate-x-1'}`} />
  </button>
)

export const AttendanceRow = ({ row, error, isExtra, onTogglePresent, onChangeExtraHours, onRemoveExtra }) => {
  const { t } = useTranslation()
  const contract = row.contract_type
  const contractCls = CONTRACT_TYPE_BADGE_CLASS[contract] || CONTRACT_TYPE_BADGE_CLASS.CUBBO

  return (
    <div className={`flex items-center gap-3 px-3 py-2 border-b ${error ? 'bg-red-50' : ''}`}>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{row.full_name || row.user?.full_name}</div>
        <div className="text-xs text-gray-500 flex gap-2 items-center">
          <span>{row.operator_type}</span>
          <span className={`inline-flex px-1.5 py-0.5 text-[10px] rounded-full border ${contractCls}`}>{contract}</span>
          {!isExtra && row.on_roster === false && (
            <span className="inline-flex px-1.5 py-0.5 text-[10px] rounded-full border bg-gray-100 text-gray-600 border-gray-200">
              {t('workforce.attendance.off_roster')}
            </span>
          )}
        </div>
        {error && <div className="text-xs text-red-700 mt-1">{error}</div>}
      </div>
      {isExtra ? (
        <>
          <div className="flex items-center gap-2">
            <label className="text-xs text-gray-600">{t('workforce.attendance.extra_hours')}</label>
            <input
              type="number"
              step="0.5"
              min="0.5"
              max="24"
              value={row.extra_hours ?? ''}
              onChange={e => onChangeExtraHours(e.target.value)}
              className="w-20 border border-gray-300 rounded-md text-sm px-2 py-1"
            />
          </div>
          <button type="button" onClick={onRemoveExtra} className="text-xs text-red-600 hover:text-red-800">
            {t('workforce.attendance.remove')}
          </button>
        </>
      ) : (
        <Toggle value={!!row.present} onChange={onTogglePresent} ariaLabel={row.full_name} />
      )}
    </div>
  )
}
